// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609031722/js/" + chunkId + "." + {"44":"9a3e1379","225":"8d9792e1","481":"b7e574ac","486":"46e70671","770":"3dbf374f"}[chunkId] + ".0.927821556631181.chunk.js";
};